import React from "react";
import PropTypes from "prop-types";
import "../BestFitCard/Badge.scss";

export const Badge = ({ label, color, hex }) => {
    return (
        <div className={`badge badge--${color}`} style={{ backgroundColor: hex }}>
            <p className="badge__label p">{label}</p>
        </div>
    );
};

Badge.propTypes = {
    hex: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.oneOf(["red", "yellow", "green", "orange", "blue"]),
};

export default Badge;
